import { render } from "./bookmark_folder_card.vue?vue&type=template&id=be28e340"
import script from "./bookmark_folder_card.js?vue&type=script&lang=js"
export * from "./bookmark_folder_card.js?vue&type=script&lang=js"

import "./bookmark_folder_card.vue?vue&type=style&index=0&id=be28e340&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__